import React, { useState, useEffect } from 'react';
import { socket } from '../socket.ts';
import { User } from '../types.ts';

type Props = {
    self: User;
    toEmail: string | null;
};

const MessageInput: React.FC<Props> = ({ self, toEmail }) => {
    const [text, setText] = useState('');

    useEffect(() => {
        console.log("MessageInput mounted with self:", self);
    }, [self]);

    const send = () => {
        if (!text.trim() || !self?.email) {
            console.warn("Send blocked: reason =>", {
                hasText: !!text.trim(),
                hasEmail: !!self?.email,
                self,
            });
            return;
        }

        console.log("EMITTING MESSAGE:", {
            fromEmail: self.email,
            toEmail,
            name: self.name,
            imageUrl: self.imageUrl,
            text,
            timestamp: new Date().toISOString(),
        });

        socket.emit('chat message', {
            fromEmail: self.email,
            toEmail,
            name: self.name,
            imageUrl: self.imageUrl,
            text,
            timestamp: new Date().toISOString(),
        });

        setText('');
    };

    return (
        <div className="message-input">
            <input
                value={text}
                onChange={e => {
                    console.log("Input changed to:", e.target.value);
                    setText(e.target.value);
                }}
                onKeyDown={e => e.key === 'Enter' && send()}
                placeholder="Type a message..."
            />
            <button onClick={send}>Send</button>
        </div>
    );
};

export default MessageInput;
